"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { splitTime, type TimeParts } from "./countdownState";
const ENDED: TimeParts = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
  expired: true
};

/**
 * Ticks once a second toward `targetDate`. Returns null until mounted so the
 * server render and the first client render agree; stops ticking once expired.
 * `endedAtRender` (decided by the server) starts in the ended state and never
 * ticks, so server HTML, hydration and the live view all match.
 */
export function useCountdown(targetDate, t0) {
  const $ = _c(4);
  const endedAtRender = t0 === undefined ? false : t0;
  const [parts, setParts] = useState(endedAtRender ? ENDED : null);
  let t1;
  let t2;
  if ($[0] !== endedAtRender || $[1] !== targetDate) {
    t1 = () => {
      if (endedAtRender) {
        return;
      }
      const targetMs = Date.parse(targetDate);
      const tick = () => {
        const next = splitTime(targetMs, Date.now());
        setParts(next);
        return next.expired;
      };
      if (tick()) {
        return;
      }
      const id = setInterval(() => {
        if (tick()) {
          clearInterval(id);
        }
      }, 1000);
      return () => clearInterval(id);
    };
    t2 = [targetDate, endedAtRender];
    $[0] = endedAtRender;
    $[1] = targetDate;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return parts;
}